import React from 'react';
import { Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import PrimaryButton from '@modules/common/components/buttons/PrimaryButton';
import config from '@config/config';

import { getDaysFromToday, formatLocalDateTime } from '../../../lib/date';
import { isExpired } from './utils';

export const AccountActiveCheckmark = () => (
  <Icon name="checkmark" color="green" size="big" style={{ marginTop: '0.5rem' }} />
);

export const AccountExpiredCheckmark = () => (
  <Icon name="remove" color={config.iconColor} size="big" style={{ marginTop: '0.5rem' }} />
);

export const UpgradeAccount = () => (
  <div>
    <p>
      <PrimaryButton as={Link} to={config.BILLING_PATH}>
        Upgrade your account
      </PrimaryButton>
    </p>
  </div>
);

type ExpirationProps = {
  validTo: Date;
};

export const ValidUntil = ({ validTo }: ExpirationProps) => {
  const validUntillText = formatLocalDateTime(validTo);
  if (isExpired(validTo)) {
    return <p>{`Expired on ${validUntillText}.`}</p>;
  }
  return <p>{`Valid until ${validUntillText}.`}</p>;
};

export const ExpiresIn = ({ validTo }: ExpirationProps) => {
  const expiresInDays = getDaysFromToday(validTo);
  if (isExpired(validTo)) {
    return <p>{`Expired on ${formatLocalDateTime(validTo)}.`}</p>;
  }
  return <p>{`Your trial account expires in ${expiresInDays} days.`}</p>;
};
